import { render, staticRenderFns } from "./r-input-number.vue?vue&type=template&id=1a056a16&scoped=true"
import script from "./r-input-number.vue?vue&type=script&setup=true&lang=js"
export * from "./r-input-number.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-input-number.vue?vue&type=style&index=0&id=1a056a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a056a16",
  null
  
)

export default component.exports